import { get } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { Asset, FormValues, PropertyAsset } from '@funnels/types';

import { Panel, PanelHeading } from '../_common/style';
import { ConstructionLoanLayout, NewPurchaseLayout, PreapprovalLayout, RefinanceLayout } from './layouts';

export interface PropertyInvolvedInLoanPanelProps {
  layout: FIELD_VALUES;
  currentValues: FormValues;
}

const PropertyInvolvedInLoanPanel = (props: PropertyInvolvedInLoanPanelProps) => {
  const assets: Asset[] = get(props.currentValues, FIELD_PATHS.ASSETS(), []);
  const propertiesCount = assets.filter((asset) => asset.type === ASSET_TYPE.PROPERTY).length;
  const getLayout = (asset: PropertyAsset, index: number) => {
    switch (props.layout) {
      case FIELD_VALUES.CONSTRUCTION_LOAN:
        return (
          <ConstructionLoanLayout
            key={`readonly-construction-${asset.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.NEW_PURCHASE:
        return (
          <NewPurchaseLayout
            key={`readonly-newPurchase-${asset.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.PREAPPROVAL:
        return (
          <PreapprovalLayout
            key={`readonly-preapproval-${asset.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.REFINANCE:
        return (
          <RefinanceLayout
            key={`readonly-refinance-${asset.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Panel>
      <PanelHeading>{`Property involved in loan (${propertiesCount})`}</PanelHeading>
      {assets.map((asset, index) => (asset.type === ASSET_TYPE.PROPERTY ? getLayout(asset, index) : null))}
    </Panel>
  );
};

export default PropertyInvolvedInLoanPanel;
